import React, { forwardRef } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import {
  TypographyAlignToClassNameMap,
  TypographyColorToCNMap,
  TypographyLetterSpacingToClassNameMap,
  MapTypographyFontFamilyToCN,
  TypographyVariantToTagMap,
  TypographyVariant,
  TypographyLetterSpacing,
  TypographyColor, TypographyAlign, TypographyFontFamily
} from "./Typography.constants";

import styles from "./Typography.module.scss";

const Typography = forwardRef(({
  tag, variant, style, className,
  align, fontFamily, color, clamp, threeDots, hoverable, letterSpacing,
  ...restProps
}, ref) => {
  const fontFamilyFinal =
    fontFamily ?? ((variant?.includes("h") || variant?.includes("subtitle"))
      ? MapTypographyFontFamilyToCN.bebas
      : variant ? MapTypographyFontFamilyToCN.roboto : "");
  const TagFinal = tag ?? (variant ? TypographyVariantToTagMap[variant] : "span");

  return (
    <TagFinal
      style={{
        "--clamp": clamp ? clamp : undefined,
        ...style
      }}
      className={classnames(
        className,
        styles["typography"],
        styles[fontFamilyFinal],
        styles[variant],
        color ? styles[TypographyColorToCNMap[color]] : undefined,
        align ? styles[TypographyAlignToClassNameMap[align]] : undefined,
        letterSpacing ? styles[TypographyLetterSpacingToClassNameMap[letterSpacing]] : undefined,
        {
          [styles["three-dots"]]: threeDots,
          [styles["line-clamp"]]: clamp,
          [styles["hoverable"]]: hoverable,
        })}
      {...restProps}
      ref={ref}
    />
  );
});

Typography.propTypes = {
  tag: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,

  threeDots: PropTypes.bool,
  hoverable: PropTypes.bool,
  clamp: PropTypes.number,

  align: PropTypes.oneOf(Object.values(TypographyAlign)),
  fontFamily: PropTypes.oneOf(Object.values(TypographyFontFamily)),
  variant: PropTypes.oneOf(Object.values(TypographyVariant)),
  letterSpacing: PropTypes.oneOf(Object.values(TypographyLetterSpacing)),
  color: PropTypes.oneOf(Object.values(TypographyColor)),
};

Typography.align = TypographyAlign;
Typography.fontFamily = TypographyFontFamily;
Typography.variant = TypographyVariant;
Typography.letterSpacing = TypographyLetterSpacing;
Typography.color = TypographyColor;

export default Typography;
